import { reloadOnUpdate } from 'src/utils/routing/reload-on-update';
import { rootMiddleware } from './loaders/root-middleware';
// import { BlankLoading } from 'src/navigation/BlankLoading';

import {
  adminRoutes,
  authRoutes,
  loansRoutes,
  profileRoute,
  exceptionRoutes,
  legacyRedirectRoutes,
  publicRoutes,
  retainersRoutes,
  tradingRoutes,
  dexRoutes,
} from './components';
import type { RouteObject } from 'react-router';

export const routesConfig: RouteObject[] = [
  ...publicRoutes,
  ...legacyRedirectRoutes,
  {
    path: '/',
    middleware: [rootMiddleware],
    lazy: {
      loader: async () => (await import('src/routes/loaders/root-loader')).rootLoader,
      Component: async () => (await reloadOnUpdate(async () => import('src/pages/root'))()).default,
      ErrorBoundary: async () =>
        (await reloadOnUpdate(async () => import('src/pages/Error'))()).default,
      // HydrateFallback: async () => Promise.resolve(BlankLoading),
    },
    children: [
      profileRoute,
      loansRoutes,
      retainersRoutes,
      adminRoutes,
      tradingRoutes,
      dexRoutes,
      ...exceptionRoutes,
    ],
  },

  ...authRoutes,
];
